import React, { useState } from 'react';
import { useMarketingChannelQuery } from '../../../../services/RefDataMarketingChannelApi';
import Section from '../../../Section';
import MarketingQuestionPrimary from './Questions/MarketingQuestionPrimary';
import MarketingQuestionSecondary from './Questions/MarketingQuestionSecondary';

export interface MarketingQuestionsProps {
  parentValue?: string;
  topDivider?: boolean;
  headerTitle?: string;
  questionLabel: string;
}

const MarketingQuestions = ({
  parentValue,
  topDivider = false,
  headerTitle,
  questionLabel,
}: MarketingQuestionsProps): JSX.Element => {
  const [parentSelected, setParentSelected] = useState<string | undefined>(parentValue);
  const { data } = useMarketingChannelQuery();

  const firstLevelData = data?.filter((source) => source.parentValue === undefined);
  const parentData = firstLevelData?.find((parent) => {
    return parent.code === parentSelected;
  });
  const secondLevelData = parentSelected ? data?.filter((source) => source.parentValue === parentData?.value) : [];

  return (
    <>
      {topDivider && <hr />}
      <Section title={headerTitle} data-testid="additional-information">
        <MarketingQuestionPrimary
          data={firstLevelData}
          onOptionSelected={setParentSelected}
          questionLabel={questionLabel}
        />
        <MarketingQuestionSecondary data={secondLevelData} />
      </Section>
    </>
  );
};

export default MarketingQuestions;
